import { Loader } from 'lucide-react';
import type { JSX } from 'react';

/**
 * This is a fallback element shown when the page is not loaded.
 *
 * @returns A fallback element for when the page is not loaded.
 */
export default function HydrateFallback(): JSX.Element {
  return (
    <div className="grid h-screen w-screen place-content-center">
      <Loader className="animate-spin" />
    </div>
  );
}
